import React from 'react'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import InputLabel from '@material-ui/core/InputLabel'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'

// @material-ui/icons
import Check from '@material-ui/icons/Check'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Button from 'components/CustomButtons/Button.jsx'
import CustomInput from 'components/CustomInput/CustomInput.jsx'

import Clearfix from 'components/Clearfix/Clearfix.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'

import regularFormsStyle from 'assets/jss/material-dashboard-pro-react/views/regularFormsStyle'
import Approvers from './SigningPathInputTable'
import DropdownCompanies from '../Components/DropdownCompanies'

//import DepartmentAllTables from '../Tables/DepartmentAllTables'
// Apollo thingy - removed, copy from department page if needed
// general api
import { insertSigningPath as insertOne, updateOne } from '../../services/generalServiceAPI'
import * as Utility from '../utility/utility'
import AppContext from '../../services/context'
import swal from 'sweetalert2'
import { isEmpty } from 'lodash'

const initializeLevels = (levels) => {
  let tempArray = []
  for (let i = 1; i <= levels; i++) {
    tempArray.push({
      level: i,
      approverType: '3',
      approverGroupId: '',
    })
  }
  return tempArray
}
class SigningPathProfile extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: {
        tableName: 'signingPaths',
        id: '',
        name: '',
        numberOfLevels: 6,
        companyId: '',
        isDeployed: false,
        description: '',
        levels: initializeLevels(6),
      },
      dataState: {
        numberOfLevels: 'success',
        name: 'success',
        company: 'required',
      },
      dirty: false,
    }

    this.toggle = this.toggle.bind(this)
    this.change = this.change.bind(this)
    this.handleDropdown = this.handleDropdown.bind(this)
    this.getLevelData = this.getLevelData.bind(this)
    this.save = this.save.bind(this)
    this.numberOfLevelsChanged = this.numberOfLevelsChanged.bind(this)
  }
  static contextType = AppContext
  numberOfLevelsChanged(event, minValue, maxValue) {
    const keyName = event.target.id ? event.target.id : event.target.name
    if (Utility.verifyNumber(event.target.value) && Number(event.target.value) >= minValue && Number(event.target.value) <= maxValue) {
      this.setState({
        dataState: { ...this.state.dataState, [keyName]: 'success' },

        data: {
          ...this.state.data,
          numberOfLevels: event.target.value,
          levels: initializeLevels(event.target.value),
        },
      })
    } else {
      this.setState({
        dataState: { ...this.state.dataState, [keyName]: 'error' },
        data: {
          ...this.state.data,
          numberOfLevels: event.target.value,
        },
      })
    }
  }

  // used by dropdown of company
  handleDropdown = (name) => (value) => {
    // console.log(value)
    const { data, dataState } = this.state
    // data[`${name}Name`] = value.label
    // data[`${name}Id`] = value.id
    data[name] = value
    dataState[name] = 'success'
    this.setState({
      data,
      dataState,
      dirty: true,
    })
  }

  //used by text input
  change(event) {
    const keyName = event.target.id ? event.target.id : event.target.name
    this.setState({
      data: { ...this.state.data, [keyName]: event.target.value },
      dataState: { ...this.state.dataState, [keyName]: 'success' },
      dirty: true,
    })
  }

  // get data for levels
  getLevelData(id, index, value) {
    // receiving level data from the input table
    // console.log(`get some data ${id} ${index} `, value)
    const data = this.state.data.levels
    // console.log(this.state)
    if (typeof value === 'string') {
      data[index][id] = value
      data[index]['approverGroupId'] = ''
      data[index]['approverGroupName'] = ''
    } else {
      data[index][`${id}Name`] = value.label
      data[index][`${id}Id`] = value.id ? value.id : value.value
    }
    this.setState({
      data: {
        ...this.state.data,
        levels: [...data],
        numberOfLevels: data.length || 1,
      },
      dirty: true,
    })
  }
  toggle(event) {
    const { data } = this.state
    data[event.target.id] = !this.state.data[event.target.id]
    this.setState({
      data,
      dirty: true,
    })
  }

  save() {
    // route must have a name
    if (this.state.data.name === '') {
      this.setState({ dataState: { name: 'error' } })
    }
    // didn't find how these three are set to error, no need the following if they are set to success for loaded routes
    // const { dataState } = this.state
    // if (!isEmpty(this.state.data.id)) {
    //   dataState['company'] = 'success'
    //   dataState['typeOfApplication'] = 'success'
    //   dataState['signingPath'] = 'success'
    //   console.log({ dataState })
    // } else {
    //   console.log('id?')
    // }
    ///
    try {
      this.state.data.levels.map((level, key) => {
        if (level.approverType > 1 && !level.approverGroupId) throw new Error('Please pick up a choice for level ' + level.level)
        return 0
      })

      if (this.state.dirty) {
        if (Utility.noError(this.state.dataState)) {
          const insertOrModify = (data) => (!data.id ? insertOne(data) : updateOne(data))
          // chance to clean the data to save
          const { company, receiverGroup, levels, ...withoutLevels } = this.state.data
          const modifiedLevelList = levels.map((level, key) => {
            if (level.approverType === 1) level.approverGroupId = this.context.user.id
            return level
          })

          const dataToSave = {
            ...withoutLevels,
            levels: [...modifiedLevelList],
            companyId: company.value,
            receiverGroupId: receiverGroup ? receiverGroup.value : '',
          }
          // console.log(dataToSave)
          insertOrModify(dataToSave)
            .then((response) => {
              // console.log(response)
              if (response.ok) {
                return response.json()
              } else swal.fire({ title: 'Error', html: response.url, type: 'error' })
            })
            .then((res) => {
              const recordId = res.id ? res.id : this.state.data.id
              swal.fire({ title: 'Success', html: 'This record has beend saved - ' + recordId, type: 'success', timer: 2000 })
              this.setState({
                data: {
                  ...this.state.data,
                  id: res.id,
                },
              })
            })
            .catch((e) => swal.fire({ title: 'Error', html: `General API throw an error: ${e}`, type: 'error' }))
        } else swal.fire({ title: 'Error', html: 'Please make sure all required fields are having a valid value.', type: 'error' })
      } else swal.fire({ title: 'Error', html: 'Nothing to be saved.', type: 'error' })
    } catch (e) {
      swal.fire({ title: 'Error', html: e.message, type: 'error' })
    }
  }

  componentDidMount() {
    if (this.props.match.path === '/systemadmin/create-signingpath') {
      if (this.props.data) {
        //  this is for creating new path
        this.setState({
          data: {
            ...this.state.data,
            ...this.props.data,
          },
        })
      }
    } else {
      // this block of code is hit when people clicked on the row of table to update exsiting path
      if (this.context.signingPath) {
        const { dataState } = this.state
        const { company, receiverGroup, ...rest } = this.context.signingPath
        // console.log(this.context.signingPath)
        this.setState({
          data: {
            ...this.state.data, // this is needed only for add table name
            ...rest, // this is loaded info
            company: !isEmpty(company) ? { label: company.name, value: company.id } : {},
            receiverGroup: !isEmpty(receiverGroup) ? { label: receiverGroup.name, value: receiverGroup.id } : {},
          },
          dataState: {
            ...dataState,
            company: !isEmpty(company) ? 'success' : 'required',
            // receiverGroup 是一个不再需要的功能，新 path 产生时没事，更新的时候如果它不存在会造成错误， 没办法更新，所以把 required 去掉
            // receiverGroup: !isEmpty(receiverGroup) ? 'success' : 'required',
            receiverGroup: 'success' 
          },
        })
      }
    }
  }
  //<p>{JSON.stringify(this.state.data)}</p>
  // {JSON.stringify(this.state.data.levels[this.state.data.levels.length-1]) }
  render() {
    // Pass rest to child so it won't polute their styles
    const { classes, ...rest } = this.props

    // console.log('regular form class:')
    //`1) when bring up details for editing, the company should be set already
    // 2) number of levels should have a limit
    // 3) if isDeployed, can't edit, disable the update button
    // 4) associate 2nd col with 3rd col
    // 5) pull info for 5th col`

    // console.log(this.state)
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card style={{ marginTop: '5px' }}>
              <CardBody>
                <form>
                  {/**   name*/}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <CustomInput
                        success={this.state.dataState.name === 'success'}
                        error={this.state.dataState.name === 'error'}
                        labelText='Signing Path Name'
                        id='name'
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          disabled: this.state.data.isDeployed,
                          value: this.state.data.name,
                          onChange: (event) => this.change(event),
                          type: 'text',
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                      <div className={classes.checkboxAndRadio}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              // tabIndex={-1}
                              id='isDeployed'
                              disabled={this.state.data.isDeployed}
                              checked={this.state.data.isDeployed}
                              onClick={(e) => this.toggle(e)}
                              checkedIcon={<Check className={classes.checkedIcon} />}
                              icon={<Check className={classes.uncheckedIcon} />}
                              classes={{
                                checked: classes.checked,
                                root: classes.checkRoot,
                              }}
                            />
                          }
                          classes={{
                            label: classes.label,
                          }}
                          label='Deployed'
                        />
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <DropdownCompanies
                        labelText='Company'
                        helperText='Choose a company'
                        id='company'
                        isDisabled={this.state.data.isDeployed}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        loose
                        value={this.state.data.company}
                        onChange={this.handleDropdown('company')}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                      <CustomInput
                        success={this.state.dataState.numberOfLevels === 'success'}
                        error={this.state.dataState.numberOfLevels === 'error'}
                        labelText='Number of levels'
                        id='numberOfLevels'
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          disabled: this.state.data.isDeployed,
                          value: this.state.data.numberOfLevels,
                          // min level 1, max level 10
                          onChange: (event) => this.numberOfLevelsChanged(event, 1, 15),
                          type: 'text',
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  {/* level of approvers */}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      {/**  data={this.state.data.levels} this make the dropdown overlapping again */}
                      {/** data is used to provide data for all levels assuming exists, otherwise initialize in this module and pass it down, 
                           getLevelData is the callback to retrieve modified data,
                           companyId is used to give the child module the right anchor to look for data */}
                      <Approvers
                        data={this.state.data.levels}
                        getLevelData={this.getLevelData}
                        companyId={this.state.data.company ? this.state.data.company.id : ''}
                        isDisabled={this.state.data.isDeployed}
                        {...rest}
                      />
                    </GridItem>
                  </GridContainer>

                  {/* Description */}
                  <GridContainer>
                    <GridItem xs={12}>
                      <InputLabel style={{ color: '#AAAAAA' }}>Description</InputLabel>
                      <CustomInput
                        // labelText="Anything you want to say about this company."
                        id='description'
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          multiline: true,
                          value: this.state.data.description,
                          onChange: (event) => this.change(event),
                          rows: 2,
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <Button color='rose' className={classes.updateProfileButton} onClick={this.save}>
                        Add / Update
                      </Button>
                    </GridItem>
                  </GridContainer>
                  <Clearfix />
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        {Utility.jsonPP(this.state.data)}
        {Utility.jsonPP(this.state.dataState)}
      </div>
    )
  }
}

export default withStyles(regularFormsStyle)(SigningPathProfile)
// {JSON.stringify(this.state.dataState)}
// {JSON.stringify(this.state.data)}
